import { connect } from 'react-redux';
import { getGallections, getIsReduxModuleReady } from '../redux/selectors';
import { fetchGroupGallections } from '../redux/actions';
const mapStateToProps = (state, ownprops)=>({
        gallections: getGallections(state, ownprops.group.userId, ownprops.gallectionType),
        isReduxReady: getIsReduxModuleReady(state)
    });
const mapDispatchToProps = {
    fetchGallections: fetchGroupGallections
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=GroupGallectionPopover.container.js.map